<div
  [ngClass]="{ '-mx-4 -my-3.5': snackBarConfig }"
  class="flex flex-row border border-l-4 rounded  px-4 py-3.5"
  [style.border-color]="getColour(notificationMessageConfig.borderColour)"
  [style.background-color]="getColour(notificationMessageConfig.backgroundColour)"
  [style.color]="getColour(notificationMessageConfig.textColour)"
  data-automation-id="div_notificationMessage"
>
  <!-- Word break as discussed here: https://github.com/tailwindlabs/tailwindcss/discussions/12127 -->
  <p
    class="basis-11/12 min-w-0 flex-auto break-words"
    innerHTML="{{ message }}"
  ></p>
  <button
    *ngIf="snackBarConfig"
    class="flex items-center basis-1/12"
    [style.color]="getColour(snackBarConfig.iconColour)"
    data-automation-id="button_dismiss_notification"
    (click)="dismiss()"
  >
    <i class="material-icons">{{ snackBarConfig.icon }}</i>
  </button>
</div>
